import { Link } from 'react-router-dom';
import { BookCover } from '@/components/workbooks/BookCover';
import { Eyebrow } from '@/components/editorial/Eyebrow';
import { TrustRow } from '@/components/workbooks/TrustRow';
import { workbooks, BUNDLE_PRICE, workbooksTotalValue } from '@/data/workbooks';

/**
 * The paid layer of the same knowledge system. Restrained on purpose — the
 * articles do the persuading, this only makes the next step visible.
 */
export const WorkbooksSection = () => {
  const featured = workbooks.slice(0, 3);

  return (
    <section className="py-20 md:py-28">
      <div className="container mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.1fr] gap-12 lg:gap-20 items-center">
          <div className="flex justify-center lg:justify-start">
            <div className="flex items-end">
              {featured.map((w, i) => (
                <div
                  key={w.slug}
                  className="transition-transform duration-500"
                  style={{
                    marginLeft: i === 0 ? 0 : '-28px',
                    transform: `rotate(${(i - 1) * 4}deg)`,
                    zIndex: i,
                  }}
                >
                  <BookCover title={w.title} tone={w.coverTone} size="md" hover={false} />
                </div>
              ))}
            </div>
          </div>

          <div>
            <Eyebrow variant="rules" as="div" className="mb-6">
              The Workbooks
            </Eyebrow>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-medium text-primary tracking-tight leading-[1.1]">
              Reading is the easy part
            </h2>
            <p className="mt-6 text-sm md:text-base text-muted-foreground/90 font-light leading-relaxed max-w-xl">
              The guides explain how payload, runway and mooring fees work. The workbooks make you
              sit down with your own figures and decide — seven print-ready titles, 34 to 62 pages
              each, built to be written on rather than skimmed.
            </p>
            <p className="mt-4 text-sm text-muted-foreground/90 font-light leading-relaxed">
              From ${Math.min(...workbooks.map((w) => w.price))} each. All seven together are $
              {BUNDLE_PRICE} instead of ${workbooksTotalValue}.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3">
              <Link
                to="/workbooks"
                className="btn-luxe inline-flex items-center justify-center min-h-[48px] px-8 py-3 text-[10px] tracking-luxury uppercase"
              >
                See the workbooks
              </Link>
              <Link
                to="/workbooks#sample"
                className="text-[11px] font-light text-muted-foreground/80 underline-offset-4 hover:text-accent hover:underline"
              >
                Or get four sample pages free
              </Link>
            </div>

            <TrustRow className="mt-8" showFinalSale={false} />
          </div>
        </div>
      </div>
    </section>
  );
};
